import React, { useState, useEffect } from "react";
import { Container, Grid, Typography, Button } from "@material-ui/core/";
import clsx from "clsx";
import { Icon } from "@material-ui/core/";
import { Send } from "@material-ui/icons";
import { useStyles } from "./style";
import { connect } from "react-redux";
import mapStateToProps from "./mapStateToProps";
import mapDispatchToProps from "./mapDispatchToProps";
import { useHistory } from "react-router-dom";
import Form from "components/Form/FormTwoColumns";
//import DatosCiudadano from "./DatosCiudadano";
import { functions } from "constants/index";
import ApiServices from "services/ApiServices";
import ResponseElement from "components/MensajeElement";

// Desde y Hasta Imports

function ProcesarCita(props) {
  let history = useHistory();
  const classes = useStyles(),
    [open, setOpen] = React.useState(false),
    [mensaje, setMensaje] = React.useState({
      tipoError: "success",
      tipoMensaje: "",
    }),
    [success, setSuccess] = React.useState(false),
    [apiErrors, setApiErrors] = useState([]),
    [selectedForm, setSelectedForm] = React.useState("Reprogramar");
  const newDate = new Date();
  const [horaInicioValue, setHoraInicioValue] = React.useState(""),
    [nuevaFechaCitaValue, setNuevaFechaCitaValue] = React.useState(""),
    [razonDeCambioValue, setRazonDeCambioValue] = React.useState(""),
    [razonDeCancelacionValue, setRazonDeCancelacionValue] = React.useState(""),
    [finalizarConOtroMotivoValue, setFinalizarConOtroMotivoValue] =
      React.useState(false),
    [razonDeFinalizadoValue, setRazonDeFinalizado] = React.useState("");

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  const handClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const validateChangeInputRadio = (element) => {
    //console.log("element.value:", element.value);
    if (Number(element.value) === 1) {
      // functions.clearElementValues(elementsNacional, setElementsNacional);
      setSelectedForm("Cancelar");
    } else if (Number(element.value) === 0) {
      // functions.clearElementValues(elementsExtranjero, setElementsExtranjero);
      setSelectedForm("Reprogramar");
    } else if (Number(element.value) === 2) {
      setSelectedForm("Finalizar");
    } else if (Number(element.value) === 3) {
      setSelectedForm("FinalizarCatalogo");
    }
  };

  const handlerHoraInicio = (event, value, reason) => {
    let newArray = elementsReprogramar.horaInicio.list.filter(function (
      element
    ) {
      return element.id === event.target.value;
    });
    setHoraInicioValue(newArray[0].name);
  };

  const handlerRazonFinalizado = (event, value, reason) => {
    let newArray = elementsFinalizar.razonFinalizado.list.filter(function (
      element
    ) {
      return element.id === event.target.value;
    });
    setRazonDeFinalizado(newArray[0].name);
  };

  /*   const handlerFechaCita = (event, value, reason) => {
    // Este componente no es capaz de leer los valores actualizados
    // de los siguientes hooks. Por eso, no puedo usar los hooks aquí.
    // console.log("selectedFormValue:", selectedFormValue);
    // console.log("isSelectedExtranjero:", isSelectedExtranjero);
    // console.log("zonaHorariaValue:", zonaHorariaValue);
    // console.log("elementsExtranjero:", elementsExtranjero);
    let horasDeDiferencia = 0;

    if (event.target.value != null) {
      console.log(
        "event.target.value at handlerFechaCita:",
        event.target.value
      );
      if (elementsRadioButton.extranjeroONacional.value == 1) {
        if (elementsExtranjero.zonaHoraria.value !== "") {
          let zonaHorariaId = elementsExtranjero.zonaHoraria.value;
          let zonasHorarias = elementsExtranjero.zonaHoraria.list;
          zonasHorarias.forEach((zonaHoraria) => {
            if (zonaHoraria.id == zonaHorariaId) {
              horasDeDiferencia = zonaHoraria.horasDeDiferencia;
            }
          });
          getHorariosCitas(event.target.value, horasDeDiferencia);
        } else {
          setOpen(true);
          setMensaje({
            tipoError: "error",
            tipoMensaje:
              "Debe escoger zona horaria también para ver los horarios disponibles.",
          });
        }
      } else {
        getHorariosCitas(event.target.value, horasDeDiferencia);
      }
    }
  }; */

  const handlerFechaCitaSimplificado = (event, value, reason) => {
    getHorariosCitasSimplificado(event.target.value);
  };

  /*   const getHorariosCitas = async (fechaCita, horasDeDiferencia) => {
    props.setloadingStepperSpinner(true);
    // console.log("horasDeDiferencia:", horasDeDiferencia);
    let newElements = Object.assign({}, elements);
    let requestBody = {
      fechaCita: fechaCita,
    };
    try {
      let response =
        await ApiServices.citasEmpadronamientoActualizacion.customPOST(
          "obtenerHorasParaCita",
          requestBody
        );
      if (response.error) {
        setMensaje({
          tipoError: "error",
          tipoMensaje:
            "Problemas al obtener los estados. Por favor intente más tarde.",
        });
        setOpen(true);
      } else {
        var datos = response.data;
        // console.log(
        //   "datos en citasEmpadronamientoActualizacion/obtenerHorasParaCita:",
        //   datos
        // );
        newElements.horaInicio.list = [];
        Object.keys(datos).forEach((element, key, _array) => {
          // Agregando a la lista de horas, solo las disponibles.
          if (datos[element].disponible) {
            let nuevaHora = functions.aplicarDiferenciaHoraria(
              datos[element].hora,
              horasDeDiferencia
            );
            newElements.horaInicio.list.push({
              id: datos[element].id,
              name: nuevaHora,
              horaGuatemala: datos[element].hora,
            });
          }
        });
        // functions.orderArray(newElements.horaInicio.list, "name");
        setElements(newElements);
      }
      props.setloadingStepperSpinner(false);
    } catch (error) {
      setMensaje({
        tipoError: "error",
        tipoMensaje:
          "Problemas al obtener los estados. Por favor intente más tarde.",
      });
      setOpen(true);
      newElements.horaInicio.list = [
        { id: "1", name: "07:00" },
        { id: "2", name: "07:15" },
        { id: "3", name: "07:30" },
        { id: "4", name: "07:45" },
      ];
      setElements(newElements);
      props.setloadingStepperSpinner(false);
    }
    // props.setloadingStepperSpinner(false);
  }; */

  const getHorariosCitasSimplificado = async (fechaCita) => {
    props.setloadingStepperSpinner(true);
    // console.log("horasDeDiferencia:", horasDeDiferencia);
    let newElements = Object.assign({}, elementsReprogramar);
    let requestBody = {
      fechaCita: fechaCita,
    };
    try {
      let response =
        await ApiServices.citasEmpadronamientoActualizacion.customPOST(
          "obtenerHorasParaCita",
          requestBody
        );
      if (response.error) {
        setMensaje({
          tipoError: "error",
          tipoMensaje:
            "Problemas al obtener los horarios de las citas. Por favor intente más tarde.",
        });
        setOpen(true);
      } else {
        var datos = response.data;
        // console.log(
        //   "datos en citasEmpadronamientoActualizacion/obtenerHorasParaCita:",
        //   datos
        // );
        newElements.horaInicio.list = [];
        Object.keys(datos).forEach((element, key, _array) => {
          // Agregando a la lista de horas, solo las disponibles.
          if (datos[element].disponible) {
            newElements.horaInicio.list.push({
              id: datos[element].id,
              name: datos[element].name,
            });
          }
        });
        // functions.orderArray(newElements.horaInicio.list, "name");
        setElementsReprogramar(newElements);
      }
      props.setloadingStepperSpinner(false);
    } catch (error) {
      setMensaje({
        tipoError: "error",
        tipoMensaje:
          "Problemas al obtener los horarios de las citas. Por favor intente más tarde.",
      });
      setOpen(true);
      newElements.horaInicio.list = [
        { id: "1", name: "07:00" },
        { id: "2", name: "07:15" },
        { id: "3", name: "07:30" },
        { id: "4", name: "07:45" },
      ];
      setElementsReprogramar(newElements);
      props.setloadingStepperSpinner(false);
    }
    // props.setloadingStepperSpinner(false);
  };

  const [elementsReprogramar, setElementsReprogramar] = React.useState({
    nuevaFechaCita: {
      idelement: "nuevaFechaCita",
      value: newDate,
      defaultValue: newDate,
      label: "Fecha de la Cita *",
      pattern: "^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$",
      validators: ["required"],
      errorMessages: ["Es requerido seleccionar fecha"],
      isError: false,
      elementType: "date",
      handler: handlerFechaCitaSimplificado,
      useStateHook: setNuevaFechaCitaValue,
    },
    horaInicio: {
      idelement: "horaInicio",
      value: "",
      label: "Hora de Cita *",
      pattern: "",
      validators: ["required"],
      errorMessages: ["Especifique hora de cita."],
      isError: false,
      elementType: "customDropdown",
      list: [],
      handler: handlerHoraInicio,
    },
    razonDeCambio: {
      idelement: "razonDeCambio",
      value: "",
      label: "Razón de Cambio *",
      pattern: "^([\\w_][\\w_ -.\"'Ññ]*[\\w_.\"'Ññ]){1,50}$",
      validators: ["required"],
      errorMessages: ["Sin tildes, ni espacios al inicio y final"],
      isError: false,
      elementType: "input",
      disabled: false,
      useStateHook: setRazonDeCambioValue,
    },
  });
  const [elementsCancelar, setElementsCancelar] = React.useState({
    razonDeCancelacion: {
      idelement: "razonDeCancelacion",
      value: "",
      label: "Razón de Cancelación *",
      pattern: "^([\\w_][\\w_ -.\"'Ññ]*[\\w_.\"'Ññ]){1,50}$",
      validators: ["required"],
      errorMessages: ["Sin tildes, ni espacios al inicio y final"],
      isError: false,
      elementType: "input",
      disabled: false,
      useStateHook: setRazonDeCancelacionValue,
    },
  });

  const [elementsFinalizar, setelementsFinalizar] = React.useState({
    razonFinalizado: {
      idelement: "razonFinalizado",
      value: "",
      label: "Razón de Finalización *",
      pattern: "",
      validators: ["required"],
      errorMessages: ["Especifique hora de inicio."],
      isError: false,
      elementType: "customDropdown",
      list: [
        { id: "1", name: "No era el titular del DPI." },
        { id: "2", name: "Se cortó la comunicación." },
        { id: "3", name: "No respondió la llamada." },
        { id: "4", name: "Problemas con el DPI." },
        {
          id: "5",
          name: "Pendiente de verificación de datos de empadronamiento.",
        },
      ],
      handler: handlerRazonFinalizado,
    },
  });

  const [elementsRadioButton, setElementsRadioButton] = useState({
    extranjeroONacional: {
      idelement: "extranjeroONacional",
      value: "0",
      label: "Seleccione una opción para procesar la cita.",
      isError: false,
      elementType: "radio",
      errorMessages: ["Debe seleccionar una opción"],
      options: [
        { value: "0", label: "Reprogramar" },
        { value: "1", label: "Cancelar" },
        { value: "2", label: "Finalizar" },
        { value: "3", label: "Finalizar por Otros Motivos" },
      ],
      disabled: false,
      validateChangeInputRadio: validateChangeInputRadio,
    },
  });

  const procesarCita = async () => {
    props.setloadingStepperSpinner(true);
    // console.table("props:", props)
    let allGood = true;
    let errorMessage =
      "Debe completar todos los campos obligatorios (*) del formulario.";
    let requestBody = {};
    // console.log("props en ProcesarCita method:", props);
    let nombreMetodoEndpoint = "";

    if (selectedForm === "Reprogramar") {
      nombreMetodoEndpoint = "reprogramarFechaYHora";
      allGood = functions.checkIsEmptyWhenRequiredElement(
        elementsReprogramar,
        setElementsReprogramar
      );
      // Chequeamos que los métodos llamados anteriormente hayan usado bien
      // los hooks de cada element.
      requestBody = {
        idCita: props.citaEnProceso.noCita,
        fechaCita: nuevaFechaCitaValue,
        observacion: razonDeCambioValue,
        horaCita: horaInicioValue,
      };
      Object.keys(requestBody).forEach((attribute) => {
        if (requestBody[attribute] === "" || requestBody[attribute] === null) {
          allGood = false;
        }
      });
    } else if (selectedForm === "Cancelar") {
      nombreMetodoEndpoint = "cancelarCita";

      allGood = functions.checkIsEmptyWhenRequiredElement(
        elementsCancelar,
        setElementsCancelar
      );

      // Chequeamos que los métodos llamados anteriormente hayan usado bien
      // los hooks de cada element.
      requestBody = {
        idCita: props.citaEnProceso.noCita,
        observacion: razonDeCancelacionValue,
      };
      Object.keys(requestBody).forEach((attribute) => {
        // console.log("requestBody[" + attribute + "]:", requestBody[attribute]);
        if (requestBody[attribute] === "" || requestBody[attribute] === null) {
          allGood = false;
        }
      });
    } else if (selectedForm === "FinalizarCatalogo") {
      nombreMetodoEndpoint = "finalizarCita";

      allGood = functions.checkIsEmptyWhenRequiredElement(
        elementsFinalizar,
        setelementsFinalizar
      );

      // Chequeamos que los métodos llamados anteriormente hayan usado bien
      // los hooks de cada element.
      requestBody = {
        idCita: props.citaEnProceso.noCita,
        observacion: razonDeFinalizadoValue,
      };
      Object.keys(requestBody).forEach((attribute) => {
        // console.log("requestBody[" + attribute + "]:", requestBody[attribute]);
        if (requestBody[attribute] === "" || requestBody[attribute] === null) {
          allGood = false;
        }
      });
      requestBody["idSolicitud"] = null;
    }

    // console.log("requestBody:", requestBody);

    if (selectedForm === "Reprogramar") {
      let FechaSistema = new Date();
      let diaFechaSistema = FechaSistema.getDate();

      if (allGood && nuevaFechaCitaValue) {
        if (diaFechaSistema > nuevaFechaCitaValue.getDate()) {
          allGood = false;
          errorMessage =
            "Fecha del sistema es mayor a la fecha seleccionada. Por favor seleccione una fecha válida.";
        }
      }
    }

    if (allGood) {
      // Hacer aqui la llamada al endpoint de procesado de citas
      // para cancelación y reprogramación.

      try {
        let response = "";
        if (selectedForm === "Reprogramar") {
          response =
            await ApiServices.citasEmpadronamientoActualizacion.customPOST(
              nombreMetodoEndpoint,
              requestBody
            );
        } else if (selectedForm === "Cancelar") {
          response =
            await ApiServices.citasEmpadronamientoActualizacion.customPATCH(
              nombreMetodoEndpoint,
              requestBody
            );
        } else if (selectedForm === "FinalizarCatalogo") {
          response =
            await ApiServices.citasEmpadronamientoActualizacion.customPATCH(
              nombreMetodoEndpoint,
              requestBody
            );
        }
        if (response.error) {
          setMensaje({
            tipoError: "error",
            tipoMensaje:
              "Problemas al crear registro de finalización de cita. Por favor intente más tarde.",
          });
          setOpen(true);
        } else {
          frontStep();
        }
        props.setloadingStepperSpinner(false);
      } catch (error) {
        setMensaje({
          tipoError: "error",
          tipoMensaje:
            "Problemas al crear registro de finalización de cita. Por favor intente más tarde.",
        });
        setOpen(true);
        props.setloadingStepperSpinner(false);
      }
      frontStep();
    } else {
      props.setloadingStepperSpinner(false);
      setMensaje({
        tipoError: "error",
        tipoMensaje: errorMessage,
      });
      setOpen(true);
    }
    props.setloadingStepperSpinner(false);
  };

  const frontStep = () => {
    // props.CITA_EMPADRONAMIENTO_SET_STEP(1);
    cancel();
  };

  const onClickBotonEmpadronamiento = async () => {
    // console.log(
    //   "props.citaEnProceso al hacer click en Generar Solicitud desde Citas de Empadronamiento:",
    //   props.citaEnProceso
    // );

    let idSolicitud = null;
    let requestBody = {
      cui: props.citaEnProceso.cui,
    };
    // Descomentar cuando ya este el endpoint.
   /*  let response =
      await ApiServices.citasEmpadronamientoActualizacion.customPATCH(
        "consultarSolicitudesPendientes",
        requestBody
      );

    if (response.error) {
      console.error(
        "Error al crear registro de finalización de cita:",
        response.error
      );
      setOpen(true);
    } else {
      console.log("response:", response);
      if (response.data.idSolicitud != null) {
        idSolicitud = response.data.idSolicitud;
      }
    }
    console.log("idSolicitud:", idSolicitud);

    if (idSolicitud !== null) {
      props.SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_GENERADO(idSolicitud);
    } else {
      // Mandar a llamar cuando se tiene que crear solicitud de empadronamiento por primera vez para esta cita.
      props.CITA_EMPADRONAMIENTO_SET_CITA_EN_PROCESO({
        idCita: props.citaEnProceso.noCita,
        cuiCiudadano: props.citaEnProceso.cui,
        idSolicitud: "",
        cleanRegisterOnExit: true,
      });
    } */
    props.CITA_EMPADRONAMIENTO_SET_CITA_EN_PROCESO({
      idCita: props.citaEnProceso.noCita,
      cuiCiudadano: props.citaEnProceso.cui,
      idSolicitud: "",
      cleanRegisterOnExit: true,
    });
    history.push("/solicitudesDeEmpadronamiento", {});
  };
  const finalizarConOtroMotivo = () => {
    // props.CITA_EMPADRONAMIENTO_SET_STEP(1);
    setFinalizarConOtroMotivoValue(true);
  };

  const goBackFinalizar = () => {
    // props.CITA_EMPADRONAMIENTO_SET_STEP(1);
    setFinalizarConOtroMotivoValue(false);
  };

  const cancel = () => {
    // functions.clearElementValues(elementsNacional, setElementsNacional);
    functions.clearElementValues(elementsCancelar, setElementsCancelar);
    functions.clearElementValues(elementsReprogramar, setElementsReprogramar);
    functions.clearElementValues(elementsFinalizar, setElementsReprogramar);
    props.handleClose();
    props.clearFiles();
  };
  useEffect(() => {}, []);

  return (
    <React.Fragment>
      <div className={classes.root}>
        <br />
        <Container className={classes.colorComponente}>
          <Grid container>
            <Grid
              item
              xs={12}
              container
              direction="row"
              justify="center"
              alignItems="center"
              className={classes.formTitle}
            >
              <Typography component="span" variant="body1" color="textPrimary">
                <strong>Formulario de Procesado de Cita </strong>
              </Typography>
            </Grid>
            <Grid className={classes.AlignTable} item xs={12}>
              <Form
                elements={elementsRadioButton}
                apiErrors={apiErrors}
                validateChangeInputRadio={validateChangeInputRadio}
              />
            </Grid>
            {selectedForm === "Reprogramar" ? (
              <React.Fragment>
                <Grid className={classes.comboboxGrid} item xs={12}>
                  <Form
                    key={selectedForm}
                    elements={elementsReprogramar}
                    apiErrors={apiErrors}
                  />
                </Grid>
              </React.Fragment>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {selectedForm === "Cancelar" ? (
              <React.Fragment>
                <Grid className={classes.comboboxGrid} item xs={12}>
                  <Form
                    key={selectedForm}
                    elements={elementsCancelar}
                    apiErrors={apiErrors}
                  />
                </Grid>
              </React.Fragment>
            ) : (
              <React.Fragment> </React.Fragment>
            )}

            {selectedForm === "FinalizarCatalogo" ? (
              <React.Fragment>
                <Grid className={classes.comboboxGrid} item xs={12}>
                  <Form
                    key={selectedForm}
                    elements={elementsFinalizar}
                    apiErrors={apiErrors}
                  />
                </Grid>
              </React.Fragment>
            ) : (
              <React.Fragment> </React.Fragment>
            )}

            {selectedForm === "Reprogramar" ||
            selectedForm === "Cancelar" ||
            selectedForm === "FinalizarCatalogo" ? (
              <React.Fragment>
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  justify="center"
                  alignItems="center"
                  className={classes.buttonsGrid}
                >
                  <div className={classes.wrapper}>
                    <Button
                      onClick={cancel}
                      color="secondary"
                      variant="contained"
                    >
                      <Icon className={classes.icon}> cancel </Icon> Cancelar
                    </Button>
                  </div>
                  <div className={classes.wrapper}>
                    <Button
                      variant="contained"
                      onClick={procesarCita}
                      //onClick={frontStep}
                      color="primary"
                      disabled={false}
                      className={buttonClassname}
                      endIcon={<Send />}
                    >
                      Procesar Cita
                    </Button>
                  </div>
                </Grid>
              </React.Fragment>
            ) : (
              <React.Fragment> </React.Fragment>
            )}
            {selectedForm === "Finalizar" ? (
              <React.Fragment>
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  justify="center"
                  alignItems="center"
                  className={classes.buttonsGrid}
                >
                  <div className={classes.wrapper}>
                    <Button
                      onClick={cancel}
                      color="secondary"
                      variant="contained"
                    >
                      <Icon className={classes.icon}> cancel </Icon> Cancelar
                    </Button>
                  </div>
                  <div className={classes.wrapper}>
                    <Button
                      variant="contained"
                      onClick={onClickBotonEmpadronamiento}
                      //onClick={frontStep}
                      color="primary"
                      disabled={false}
                      className={buttonClassname}
                      endIcon={<Send />}
                    >
                      Generar Solicitud de Empadronamiento o Actualización
                    </Button>
                  </div>
                </Grid>
              </React.Fragment>
            ) : (
              <React.Fragment> </React.Fragment>
            )}
          </Grid>
          <br />
          <div className={classes.lineaDegradadaBottom}></div>
        </Container>
        <br />
      </div>
      <ResponseElement
        type={mensaje.tipoError}
        content={mensaje.tipoMensaje}
        open={open}
        handClose={handClose}
      />
    </React.Fragment>
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(ProcesarCita);
